import React from 'react';
import ReactDOM from 'react-dom/client';
import { Routes,Route } from 'react-router-dom';
import Login from './pages/Login';
import DashBoard from './pages/DashBoard';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import './styles/shell.css';


const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
      <BrowserRouter>      
      <App/>
      <ToastContainer/>
    </BrowserRouter>
  </React.StrictMode>
);
